import { Route } from '@angular/router';

import {
  AgentHelpComponent,
  AgentNotificationConfirmationComponent
} from '@amfam/policy/change-coverage/feature';

import { ChangeCoverageConfirmationComponent } from '../change-coverage-confirmation/change-coverage-confirmation.component';
import { ChangeCoverageContainerComponent } from '../change-coverage-container/change-coverage-container.component';
import { ChangeCoverageSummaryComponent } from '../change-coverage-summary/change-coverage-summary.component';
import { UpdateCoverageComponent } from '../update-coverage/update-coverage.component';

export const ChangeCoverageRoutes: Route[] = [
  {
    path: ':id',
    data: {
      breadcrumb: false
    },
    component: ChangeCoverageContainerComponent,
    children: [
      {
        path: 'get-quote',
        component: UpdateCoverageComponent
      },
      {
        path: 'agent-help',
        component: AgentHelpComponent
      },
      {
        path: 'agent-help-confirmation',
        component: AgentNotificationConfirmationComponent
      },
      {
        path: 'summary',
        component: ChangeCoverageSummaryComponent
      },
      {
        path: 'confirmation',
        component: ChangeCoverageConfirmationComponent
      }
    ]
  }
];
